import * as stylex from "@stylexjs/stylex";
import { RotateCw, X } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/seasons.stylex";
import { season } from "@/theme/seasons.stylex";
import "@/theme/tokens.stylex";
import { radii, shadows } from "@/theme/tokens.stylex";
import { Button } from "@/ui/Button";
import { Eyebrow } from "@/ui/Eyebrow";
import { QrCode } from "@/ui/QrCode";
import type { QrTile } from "../qrTile";
export type QrTileShown = {
  tile: QrTile;
  secondsLeft: number;
};
type QrSignInTileProps = QrTileShown & {
  email: string;
  online: boolean;
  onRetry: () => void;
  onClose: () => void;
};
const text = copy.settings.account.qr;
const styles = {
  countdown: {
    kcqcaj: "xss6m8b",
    $$css: true
  },
  retry: {
    kGVxlE: "xnfxhx2",
    $$css: true
  },
  done: {
    koQZXg: "x1rm44br",
    $$css: true
  }
};
export function QrSignInTile({
  tile,
  secondsLeft,
  email,
  online,
  onRetry,
  onClose
}: QrSignInTileProps) {
  const failed = tile.kind === "failed";
  return <div className="xkh2ocl x78zum5 x1a02dak x6s0dn4 x15c6qxi x1qhigcl x9f619 x1fv5t7x x1ubcl0s">
      <QrCode value={tile.kind === "open" ? tile.url : undefined} label={text.label} />
      <div className="x78zum5 xdt5ytf x1cy8zhl x1v2ro7d x1jzhcrs x1iyjqo2 x1r8uery">
        <span className="xwsyq91 xfbjfs5 x1yrajzq">{text.title}</span>
        <span className="x1jvydc1 x15i68ds xfrs9s4 x1fzhlzt">{failed ? text.failed : text.body(email)}</span>
        {!failed && <Eyebrow size="caption" xstyle={styles.countdown}>
            {text.expires(secondsLeft)}
          </Eyebrow>}
        <div className="x78zum5 x1a02dak x167g77z">
          {failed && <Button variant="secondary" icon={RotateCw} disabled={!online} onClick={onRetry} xstyle={styles.retry}>
              {text.retry}
            </Button>}
          <Button variant="ghost" icon={X} onClick={onClose} xstyle={!failed && styles.done}>
            {text.done}
          </Button>
        </div>
      </div>
    </div>;
}